import { forwardRef, InputHTMLAttributes, useState } from 'react';

import Eye from './Icons/Eye';
import { EyeSlashSvg } from './Icons/EyeSlashSvg';
import TextInput, { TextInputHandle } from './TextInput';

export type PasswordInputHandle = TextInputHandle & {};

type PasswordInputProps = InputHTMLAttributes<HTMLInputElement> & {
    isPasswordButtonVisible: boolean;
};

const PasswordInputComponent = (
    { isPasswordButtonVisible, ...props }: PasswordInputProps,
    ref: React.Ref<PasswordInputHandle>,
) => {
    const [passwordVisible, setPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible((prevVisible) => !prevVisible);
    };

    return (
        <div className="flex items-center relative">
            <TextInput
                {...props}
                type={passwordVisible ? 'text' : 'password'}
                ref={ref}
            />

            {isPasswordButtonVisible && (
                <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute top-1/2 right-2 transform -translate-y-1/2 flex items-center">
                    {passwordVisible ? (
                        <Eye className="w-5 h-5 [&_path]:stroke-[1.5]" />
                    ) : (
                        <EyeSlashSvg className="w-5 h-5 [&_path]:stroke-[1.5]" />
                    )}
                </button>
            )}
        </div>
    );
};

export const PasswordInput = forwardRef<
    PasswordInputHandle,
    PasswordInputProps
>(PasswordInputComponent);
